var React = require('react');

function Icon2Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_1","data-name":"Obszar roboczy 1","transform":"translate(-3.53 -4.71)"},[React.createElement("path",{"id":"Path_480","data-name":"Path 480","d":"M19.99,18.82l-4.7,7.06v9.41h2.35V32.94H31.76v2.35h2.35V28.23h2.35V25.88H34.1l-4.71-7.06H19.98Zm1.27,2.36h6.95l3.17,4.71H18.02Zm10.5,9.41H17.64V28.24H31.76v2.35Z","key":0}),React.createElement("path",{"id":"Path_481","data-name":"Path 481","d":"M10.57,28.24h2.35V21.18h3.12l1.6-2.36H13.3l3.24-4.7h6.91l1.58,2.35h2.8l-3.14-4.71H15.27l-4.7,7.06Z","key":1}),React.createElement("path",{"id":"Path_482","data-name":"Path 482","d":"M10.59,4.71h-.01l-4.7,7.05H3.53v2.36H5.88v7.06H8.24V14.12h3.11l1.6-2.36H8.61l3.24-4.7h6.84l1.58,2.35h2.85l-3.13-4.7Z","key":2})]));
}

Icon2Inline.defaultProps = {"width":"32.93","height":"30.58","viewBox":"0 0 32.93 30.58"};

module.exports = Icon2Inline;

Icon2Inline.default = Icon2Inline;
